
import { Mapper } from "../../../../base/utils/mapper";
import { TypeHealthHabitPhysiotherapyModel } from "../../../../domain/models/consult/type-health-habit-physiotherapy.model";
import { TypeHealthHabitPhysiotherapyEntity } from "../entities/type-health-habit-physiotherapy.entity";
export class TypeHealthHabitPhysiotherapyImplementationRepositoryMapper extends Mapper<TypeHealthHabitPhysiotherapyEntity, TypeHealthHabitPhysiotherapyModel>{
        mapFrom(param:  TypeHealthHabitPhysiotherapyEntity):  TypeHealthHabitPhysiotherapyModel { 
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors
            }; 
        }
        mapTo(param:  TypeHealthHabitPhysiotherapyModel):  TypeHealthHabitPhysiotherapyEntity {
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors 
            };
        }
    }